import React, { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getGrantDataAPI } from "../../../redux/action/common-action";
import { parseHtml } from "../../../utils/util";

const Grant = ({ getGrantDataAPI, grantData }) => {
  const style1 = {
    boxShadow: "0 0 -0.75rem 0 var(--rgba-primary-2)",
  };
  const style = {
    backgroundColor: "var(--theme-orange)",
  };

  useEffect(() => {
    getGrantDataAPI();
  }, []);
  const [details, setDetails] = useState();

  const topSection = grantData && grantData.topSection;
  const grantCategory = grantData && grantData.grantCategory;
  const grantCategoryDetails = grantData && grantData.grantCategoryDetails;

  const handleCategory = (id) => {
    const data = grantCategoryDetails.filter((f) => f.key == id);
    setDetails(data);
  };

  return (
    <>
      <section className="grant-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <Link to="/" className="grant-back-btn">
                <i className="bi bi-chevron-left"></i> {topSection && topSection.ctaText}
              </Link>
              <p className="h6">{topSection && topSection.sortTitle}</p>
              <p className="h1">{topSection && topSection.title}</p>
              <p className="para">{topSection && topSection.desc}</p>
              <div className="img-container">
                <img src="https://sach-public-file.s3.ap-south-1.amazonaws.com/Grant/hero-img.png" alt="Hero Image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container py-5">
          <div className="row">
            <div className="col-md-12">
              <div className="sach-nav-tabs grant-nav-tabs">
                <div className="nav nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                  {grantCategory &&
                    grantCategory.map((item, index) => (
                      <button className={`nav-link ${item && item.key == 1 ? "active" : ""}`} id={`v-pills-tab-${item && item.key}`} data-bs-toggle="pill" data-bs-target={`#v-tab-${item && item.key}`} type="button" role="tab" aria-controls={`v-tab-${item && item.key}`} aria-selected="true" style={style1} key={index} onClick={(e) => handleCategory(item && item.key)}>
                        {item && item.categoryName}
                      </button>
                    ))}
                </div>
                <div className="tab-content" id="v-pills-tabContent">
                  {details ? (
                    <div className="tab-pane fade show active" id="v-tab-1" role="tabpanel" aria-labelledby="v-pills-tab-1">
                      <div className="h1">{details && details[0] && details[0].title}</div>
                      <div className="h5">{details && details[0] && details[0].sortTitle}</div>
                      <img src={details && details[0] && details[0].imageUrl} alt="Grants" />
                      <p>{details && details[0] && parseHtml(details[0].desc)}</p>
                      {details && details[0] && details[0].desc1 && <p> {details && details[0] && parseHtml(details[0].desc1)}</p>}
                      {details && details[0] && details[0].desc2 && <p> {details && details[0] && parseHtml(details[0].desc2)}</p>}
                      {details && details[0] && details[0].desc3 && <p> {details && details[0] && parseHtml(details[0].desc3)}</p>}
                      {details && details[0] && details[0].desc4 && <p> {details && details[0] && parseHtml(details[0].desc4)}</p>}
                      {details && details[0] && details[0].cta && details[0].key != 4 && details[0].key != 5 && (
                        <a href={details[0].linkUrl} target="_blank" className="btn btn-sach bg-sach">
                          {parseHtml(details[0].cta)}
                          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <g id="Property 1=arrow-right">
                              <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M5 13H16.865L13.232 17.36C12.878 17.784 12.936 18.415 13.36 18.768C13.785 19.122 14.415 19.064 14.769 18.64L19.769 12.64C19.808 12.593 19.827 12.538 19.856 12.486C19.88 12.444 19.909 12.408 19.927 12.362C19.972 12.247 19.999 12.126 19.999 12.004C19.999 12.003 20 12.001 20 12C20 11.999 19.999 11.997 19.999 11.996C19.999 11.874 19.972 11.753 19.927 11.638C19.909 11.592 19.88 11.556 19.856 11.514C19.827 11.462 19.808 11.407 19.769 11.36L14.769 5.36C14.57 5.123 14.286 5 14 5C13.774 5 13.547 5.076 13.36 5.232C12.936 5.585 12.878 6.216 13.232 6.64L16.865 11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13Z" />
                            </g>
                          </svg>
                        </a>
                      )}
                    </div>
                  ) : (
                    <div className="tab-pane fade show active" id="v-tab-1" role="tabpanel" aria-labelledby="v-pills-tab-1">
                      <div className="h1">{grantCategoryDetails && grantCategoryDetails[0] && grantCategoryDetails[0].title}</div>
                      <div className="h5">{grantCategoryDetails && grantCategoryDetails[0] && grantCategoryDetails[0].sortTitle}</div>
                      <img src={grantCategoryDetails && grantCategoryDetails[0] && grantCategoryDetails[0].imageUrl} alt="Grants" />
                      <p>{grantCategoryDetails && grantCategoryDetails[0] && parseHtml(grantCategoryDetails[0].desc)}</p>
                      {grantCategoryDetails && grantCategoryDetails[0] && grantCategoryDetails[0].desc1 && <p> {grantCategoryDetails && grantCategoryDetails[0] && parseHtml(grantCategoryDetails[0].desc1)}</p>}
                      {grantCategoryDetails && grantCategoryDetails[0] && grantCategoryDetails[0].desc2 && <p> {grantCategoryDetails && grantCategoryDetails[0] && parseHtml(grantCategoryDetails[0].desc2)}</p>}
                      {grantCategoryDetails && grantCategoryDetails[0] && grantCategoryDetails[0].desc3 && <p> {grantCategoryDetails && grantCategoryDetails[0] && parseHtml(grantCategoryDetails[0].desc3)}</p>}
                      {grantCategoryDetails && grantCategoryDetails[0] && grantCategoryDetails[0].desc4 && <p> {grantCategoryDetails && grantCategoryDetails[0] && parseHtml(grantCategoryDetails[0].desc4)}</p>}
                      {grantCategoryDetails && grantCategoryDetails[0] && (
                        <a href="https://www.madhavnetralaya.org/" target="_blank" className="btn btn-sach" style={style}>
                          {parseHtml(grantCategoryDetails[0].cta)}
                          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <g id="Property 1=arrow-right">
                              <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M5 13H16.865L13.232 17.36C12.878 17.784 12.936 18.415 13.36 18.768C13.785 19.122 14.415 19.064 14.769 18.64L19.769 12.64C19.808 12.593 19.827 12.538 19.856 12.486C19.88 12.444 19.909 12.408 19.927 12.362C19.972 12.247 19.999 12.126 19.999 12.004C19.999 12.003 20 12.001 20 12C20 11.999 19.999 11.997 19.999 11.996C19.999 11.874 19.972 11.753 19.927 11.638C19.909 11.592 19.88 11.556 19.856 11.514C19.827 11.462 19.808 11.407 19.769 11.36L14.769 5.36C14.57 5.123 14.286 5 14 5C13.774 5 13.547 5.076 13.36 5.232C12.936 5.585 12.878 6.216 13.232 6.64L16.865 11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13Z" />
                            </g>
                          </svg>
                        </a>
                      )}
                      {/* {console.table(grantCategoryDetails)} */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state,
    grantData: state?.CommonReducer?.grantData || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGrantDataAPI: () => dispatch(getGrantDataAPI()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Grant);
